<div class="services-dialog">
  <div class="services-dialog-header d-flex justify-content-between align-items-center">
    <div class="title">Confirmation</div>
    <div class="services-dialog-close-button" (click)="exit(0)">
      <mat-icon style="cursor: pointer">close</mat-icon>
    </div>
  </div>
  <div class="services-dialog-body col-12 justify-content-center" [formGroup]="form">
    <div class="pb-2 row justify-content-between">
      <div class="col-7 pr-1">
        <span class="label">Offer code</span>
        <nb-form-field>
          <input type="text" nbInput fullWidth shape="rectangle" placeholder="" formControlName="code" />
          <!--<mat-icon matTooltip="Choose a name for your persona. This name category will appear on the badge when printed." nbSuffix>help_outline</mat-icon> -->
        </nb-form-field>
        @if(form.get('code')?.invalid && form.get('code')?.touched) {
        <div class="tw-text-red-500 tw-text-xs tw-mt-1">Offer code is required</div>
        }
      </div>
      <div class="col-5 pl-1">
        <span class="label">Limited to</span>
        <nb-form-field>
          <input type="text" nbInput fullWidth shape="rectangle" placeholder="0 = Unlimited" formControlName="max_usage" />
        </nb-form-field>
        @if(form.get('max_usage')?.invalid && form.get('max_usage')?.touched) {
        <div class="tw-text-red-500 tw-text-xs tw-mt-1">Please enter a valid number</div>
        }
      </div>
    </div>
    <div class="pb-2 row justify-content-between">
      <div class="col-12">
        <span class="label">Discount amount</span>
        <div class="row">
          <div class="col-10">
            <nb-form-field>
              <input type="text" nbInput fullWidth shape="rectangle" placeholder="" formControlName="amount" />
            </nb-form-field>
            @if(form.get('amount')?.invalid && form.get('amount')?.touched) {
            <div class="tw-text-red-500 tw-text-xs tw-mt-1">
              {{form.get('amount')?.errors?.['required'] ? 'Discount amount is required' : 'Please enter a valid number'}}
            </div>
            }
          </div>
          <div class="col-2 d-flex flex-column pl-0 justify-content-center">
            <nb-form-field>
              <div class="radio up">
                <input type="radio" nbInput name="type" value="2" id="radio1" formControlName="type" />
                <label for="radio1">%</label>
              </div>
              <div class="radio">
                <input type="radio" nbInput name="type" value="1" id="radio2" formControlName="type" />
                <label class="text-uppercase" for="radio2">{{ currency }}</label>
              </div>
            </nb-form-field>
          </div>
        </div>
      </div>
    </div>
    <div class="pb-2 row justify-content-between">
      <div class="col-12">
        <span class="label">Expiry date</span>
        <nb-form-field>
          <nb-datepicker #datepicker></nb-datepicker>
          <input [nbDatepicker]="datepicker" nbInput fullWidth shape="rectangle" formControlName="expiry_date" />
        </nb-form-field>
      </div>
    </div>
    <div class="pb-2 row justify-content-between promocodes-list">
      <div class="col-12">
        <span *ngFor="let promocode of promocodes" class="badge badge-pill badge-danger tag" [ngClass]="{ selected: promocode === editing }" (click)="selectCode(promocode)">
          {{ promocode.code }}</span
        >
      </div>
    </div>
    <div class="row justify-content-between px-3 pb-3">
      <button *ngIf="!!!editing" type="submit" class="col appearance-filled shape-rectangle size-large status-primary" nbButton (click)="create()">Create</button>
      <button *ngIf="!!editing" type="submit" class="col-5 appearance-filled shape-rectangle size-large status-primary" nbButton (click)="update()">Update</button>
      <button *ngIf="!!editing" type="submit" class="col-5 appearance-filled shape-rectangle size-large status-danger" nbButton (click)="delete()">Delete</button>
    </div>
  </div>
</div>
